// API Configuration
import ENVIRONMENT from './environment.js';

// URLs da API por ambiente
const API_URLS = {
  prod: 'https://scavai.semeao.eti.br/api',
  dev: 'http://localhost:8000/api', // Ajuste a URL de desenvolvimento conforme necessário
};

// Seleciona a URL base conforme o ambiente
export const API_BASE_URL = API_URLS[ENVIRONMENT] || API_URLS.prod;

// URL base do host (sem o /api) para acessar arquivos em /storage
export const STORAGE_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, '');

export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/login`,
  LOGOUT: `${API_BASE_URL}/logout`,
  USER: `${API_BASE_URL}/user`,
  SUPERMARKET: `${API_BASE_URL}/supermarket`,
  SUPERMARKET_ADDRESS: `${API_BASE_URL}/supermarket/address`,
  CATEGORY: `${API_BASE_URL}/category`,
  CATEGORY_API: `${API_BASE_URL}/categoryapi`,
  PRODUCT: `${API_BASE_URL}/product`,
  PRODUCT_SCAN: `${API_BASE_URL}/product/scan`,
  FLYER_SCAN: `${API_BASE_URL}/flyers/scan`,
  PRODUCT_SEARCH: `${API_BASE_URL}/product/search`,
  FLYER_PRODUCTS: `${API_BASE_URL}/flyerProducts`,
  FLYER_PRODUCTS_PROCESS: `${API_BASE_URL}/flyerProducts/process`,
  FLYER_PRODUCTS_PROCESSED: (id) => `${API_BASE_URL}/flyerProducts/${id}/processed`,
  FLYER_PRODUCTS_DEACTIVATE: (id) => `${API_BASE_URL}/flyerProducts/${id}/deactivate`,
  FLYERS_SUPERMARKET: (id) => `${API_BASE_URL}/flyers/supermarket/${id}`,
  FLYER_PRODUCTS_BY_FLYER: (id) => `${API_BASE_URL}/flyers/${id}/products`,
  FLYER_PRODUCT_CREATE: `${API_BASE_URL}/flyers/products`,
  FLYER_PRODUCTS_CATALOG: `${API_BASE_URL}/flyers/products-catalog`,
  FLYER_PRODUCT_IMAGE: (id) => `${API_BASE_URL}/flyers/products-catalog/${id}/image`,
  FLYER_PRODUCT_UPDATE: (id) => `${API_BASE_URL}/flyers/products-catalog/${id}`,
  FLYER_PRODUCT_DEACTIVATE: (id) => `${API_BASE_URL}/flyers/products-catalog/${id}/deactivate`,
  FLYER_PRODUCT_PRICE_DEACTIVATE: (id) => `${API_BASE_URL}/flyers/product-prices/${id}/deactivate`,
  FLYER_PRODUCT_PRICE_UPDATE: (id) => `${API_BASE_URL}/flyers/product-prices/${id}`,
  SUPERMARKET_PRODUCTS_PRICES: (id) => `${API_BASE_URL}/flyers/products-catalog/${id}/prices`,
  PRICE: `${API_BASE_URL}/price`,
  TOKENS: `${API_BASE_URL}/tokens`,
  COSMOS_SEARCH: `${API_BASE_URL}/cosmos/search`,
};

// API Helper functions
export const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  
  const defaultOptions = {
    headers: {
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers,
    },
  };

  // Only add Content-Type if it's not FormData
  if (!(options.body instanceof FormData)) {
    defaultOptions.headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(endpoint, {
    ...defaultOptions,
    ...options,
  });

  return response;
};

export const handleApiResponse = async (response) => {
  // Verifica o Content-Type antes de tentar parsear JSON
  const contentType = response.headers.get('content-type');
  
  // Tenta parsear como JSON apenas se for JSON válido
  let data;
  try {
    const text = await response.text();
    if (contentType && contentType.includes('application/json')) {
      data = JSON.parse(text);
    } else {
      // Se não for JSON, pode ser HTML de erro
      console.error('Resposta não é JSON:', text.substring(0, 200));
      throw new Error(`Resposta inválida do servidor. Status: ${response.status}`);
    }
  } catch (parseError) {
    console.error('Erro ao parsear resposta:', parseError);
    throw new Error(`Erro ao processar resposta do servidor. Status: ${response.status}`);
  }
  
  if (!response.ok) {
    // If it's an authentication error (401), redirect to login
    if (response.status === 401) {
      // Clear any existing token
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Redirect to login
      if (window.location.pathname !== '/sign-in') {
        window.location.href = '/sign-in';
      }
      return;
    }
    
    const apiError = new Error(data.message || data.error || `API request failed with status ${response.status}`);
    apiError.data = data;
    apiError.status = response.status;
    throw apiError;
  }
  
  return data;
};
